import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { FormlyModule } from "@ngx-formly/core";
import { UiSchemaModule } from "@vp/data-access/ui-schema";
import { FormlyJsonSchemaModule } from "@vp/formly/json-schema";
import { AddTagDialogComponent } from "./add-tag-dialog.component";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    FormlyModule.forChild(),
    FormlyJsonSchemaModule,
    UiSchemaModule
  ],
  declarations: [AddTagDialogComponent],
  exports: [AddTagDialogComponent]
})
export class AddTagModule {}
